module.exports = __webpack_public_path__ + "img/answer-c3-3.5d35112a.png";